import { Action } from '../../types/redux';
import { SET_FILTERS } from './actions';

type State = {};

export const initialState = {
  puolue: null,
  liitto: null,
  search: null,
  kunta: null,
  alue: null,
  maxValue: 9,
  minValue: 0,
  currentPage: 1,
};

const reducer = (state: State = initialState, action: Action) => {
  switch (action.type) {
    case SET_FILTERS:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

export default reducer;
